<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-number-input
    *nspVisible="
      offshoreStore.vm().isFieldVisible(tabId, sectionId, 'reportNumber')
    "
    id="reportNumber"
    name="reportNumber"
    label="Report Number"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('reportNumber')"
    [readonly]="isFieldReadOnly('reportNumber')"
    [value]="store.reportDetails?.()?.reportNumber?.value"
    [ngModel]="store.reportDetails?.()?.reportNumber?.value"
  />
  <nsp-text-input
    *nspVisible="
      offshoreStore.vm().isFieldVisible(tabId, sectionId, 'voyageNumber')
    "
    id="voyageNumber"
    name="voyageNumber"
    label="Voyage Number"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('voyageNumber')"
    [readonly]="isFieldReadOnly('voyageNumber')"
    [value]="store.voyageDetails?.()?.voyageNumber?.value"
    [ngModel]="store.voyageDetails?.()?.voyageNumber?.value"
  />
</form>
